module.exports = __webpack_public_path__ + "static/img_9830-947ae18539230c6158f2648b2e7702ab.webp";